<template>
  <nav class="sidebar">
    <!-- Brand -->
    <div class="sidebar-brand">
      <img src="/logo.svg" alt="ubuHle" class="sidebar-brand-logo" />
    </div>

    <!-- Shop selector -->
    <div v-if="shops.length" class="sidebar-shop-selector">
      <label class="sidebar-label">Active Shop</label>
      <div class="sidebar-select-wrap">
        <i class="bi bi-shop sidebar-select-icon"></i>
        <select v-model="activeShopId" class="sidebar-select">
          <option v-for="shop in shops" :key="shop.shopId" :value="shop.shopId">
            {{ shop.name }}
          </option>
        </select>
        <i class="bi bi-chevron-down sidebar-select-chevron"></i>
      </div>
    </div>

    <!-- Navigation -->
    <ul class="sidebar-nav">
      <li>
        <router-link :to="{ name: 'Dashboard' }" class="sidebar-link" active-class="sidebar-link--active">
          <i class="bi bi-grid-1x2"></i><span>Dashboard</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'Shops' }" class="sidebar-link" active-class="sidebar-link--active">
          <i class="bi bi-shop"></i><span>My Shops</span>
        </router-link>
      </li>

      <template v-if="activeShopId">
        <li class="sidebar-section-label">Manage Shop</li>
        <li>
          <router-link :to="{ name: 'Bookings', params: { shopId: activeShopId } }" class="sidebar-link" active-class="sidebar-link--active">
            <i class="bi bi-calendar-check"></i><span>Bookings</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Services', params: { shopId: activeShopId } }" class="sidebar-link" active-class="sidebar-link--active">
            <i class="bi bi-list-stars"></i><span>Services</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Stylists', params: { shopId: activeShopId } }" class="sidebar-link" active-class="sidebar-link--active">
            <i class="bi bi-person-badge"></i><span>Stylists</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Queue', params: { shopId: activeShopId } }" class="sidebar-link" active-class="sidebar-link--active">
            <i class="bi bi-people"></i><span>Queue</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'BookingSlots', params: { shopId: activeShopId } }" class="sidebar-link" active-class="sidebar-link--active">
            <i class="bi bi-clock"></i><span>Booking Slots</span>
          </router-link>
        </li>
      </template>
    </ul>

    <!-- Footer -->
    <div class="sidebar-footer">
      <div v-if="user" class="sidebar-user">
        <div class="sidebar-avatar">{{ initials }}</div>
        <div class="sidebar-user-info">
          <div class="sidebar-user-name">{{ user.firstName }} {{ user.lastName }}</div>
          <div class="sidebar-user-email">{{ user.email }}</div>
        </div>
      </div>
      <button class="sidebar-logout" @click="logout">
        <i class="bi bi-box-arrow-left"></i>
      </button>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'AppSidebar',
  computed: {
    user () { return this.$store.getters['auth/user'] },
    shops () { return this.$store.getters['shops/shops'] },
    initials () {
      if (!this.user) return '?'
      return `${this.user.firstName?.[0] || ''}${this.user.lastName?.[0] || ''}`.toUpperCase()
    },
    activeShopId: {
      get () { return this.$store.getters['shops/activeShopId'] },
      set (val) { this.$store.commit('shops/SET_ACTIVE_SHOP', val) }
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('auth/logout')
      this.$router.push({ name: 'Login' })
    }
  }
}
</script>

<style scoped>
.sidebar {
  width: 240px;
  min-height: 100vh;
  background: #212121;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  position: sticky;
  top: 0;
  height: 100vh;
  overflow-y: auto;
}

/* Brand */
.sidebar-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 22px 20px 18px;
  border-bottom: 1px solid rgba(255,255,255,0.06);
}
.sidebar-brand-logo {
  width: 80px;
  height: 36px;
  object-fit: contain;
  flex-shrink: 0;
}

/* Shop selector */
.sidebar-shop-selector {
  padding: 14px 16px;
  border-bottom: 1px solid rgba(255,255,255,0.06);
}
.sidebar-label {
  display: block;
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: rgba(255,255,255,0.35);
  margin-bottom: 6px;
  font-weight: 600;
}
.sidebar-select-wrap {
  position: relative;
  display: flex;
  align-items: center;
}
.sidebar-select-icon {
  position: absolute; left: 9px;
  color: rgba(255,255,255,0.4); font-size: 0.8rem; pointer-events: none;
}
.sidebar-select-chevron {
  position: absolute; right: 9px;
  color: rgba(255,255,255,0.3); font-size: 0.7rem; pointer-events: none;
}
.sidebar-select {
  width: 100%;
  background: rgba(255,255,255,0.07);
  border: 1px solid rgba(255,255,255,0.1);
  color: #fff;
  border-radius: 8px;
  padding: 7px 28px 7px 28px;
  font-size: 0.82rem;
  appearance: none;
  cursor: pointer;
  outline: none;
  transition: border-color 0.15s;
}
.sidebar-select:focus { border-color: rgb(255,152,0); }
.sidebar-select option { background: #2a2a2a; }

/* Nav */
.sidebar-nav {
  list-style: none;
  padding: 12px 10px;
  margin: 0;
  flex: 1;
}
.sidebar-section-label {
  font-size: 0.62rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: rgba(255,255,255,0.28);
  font-weight: 700;
  padding: 14px 10px 6px;
}
.sidebar-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  border-radius: 8px;
  color: rgba(255,255,255,0.55);
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 500;
  transition: color 0.15s, background 0.15s;
  margin-bottom: 2px;
}
.sidebar-link i { font-size: 1rem; flex-shrink: 0; }
.sidebar-link:hover {
  color: #fff;
  background: rgba(255,255,255,0.06);
  text-decoration: none;
}
.sidebar-link--active {
  color: rgb(255, 152, 0) !important;
  background: rgba(255,152,0,0.1) !important;
  font-weight: 600;
}

/* Footer */
.sidebar-footer {
  padding: 14px 16px;
  border-top: 1px solid rgba(255,255,255,0.06);
  display: flex;
  align-items: center;
  gap: 10px;
}
.sidebar-avatar {
  width: 34px; height: 34px;
  background: rgb(255,152,0);
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  color: #fff; font-size: 0.8rem; font-weight: 700;
  flex-shrink: 0;
}
.sidebar-user-info { flex: 1; min-width: 0; }
.sidebar-user-name {
  font-size: 0.8rem; font-weight: 600; color: #fff;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.sidebar-user-email {
  font-size: 0.68rem; color: rgba(255,255,255,0.35);
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.sidebar-logout {
  background: none; border: none; cursor: pointer;
  color: rgba(255,255,255,0.3); font-size: 1rem;
  padding: 4px; border-radius: 6px; transition: color 0.15s, background 0.15s;
  flex-shrink: 0;
}
.sidebar-logout:hover { color: #ef5350; background: rgba(239,83,80,0.1); }
</style>
